import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logout from "./Logout";

const ProfileDropdown = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className="dropdown profile-dropdown">
      <button
        className="notification-btn dropdown-toggle p-0"
        type="button"
        onClick={() => navigate("/dashboard")}
      >
        <img
          src={user?.image_url ? user?.image_url : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
          alt=""
        />
      </button>
      <Logout
        open={open}
        handleClose={handleClose}
      />
    </div>
  );
};

export default ProfileDropdown;
